import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import error from '../../../../../common/nodejs/errors';
import { REQUEST_STATUS_COMPLETED } from '../../../../../../../share/src/util/api/polling';
import { PHASE } from './constants';
import { terminate } from './terminate';
const moment = require('moment');

/** 
 * ファイル保存
 * @param {object} self this インスタンス
 */
export async function upload(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        is_special: true,
        type: 'upload',
        file_name: self.binFileName,
        files: self.s3FilePathList
      },
      // エラー発生のコールバックを実装
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!response) {
      // pollingWspApiはエラーコールバックの終了を待たずnullを返す
      // 非同期処理を含んでいるshowUnexpectedErrorが呼ばれた場合、スピナー消えてしまうためPromiseの解決を待つ
      if (self.exitPromise) await self.exitPromise;
      return;
    }

    // 正常コールバック
    if (response.data?.status === REQUEST_STATUS_COMPLETED) {
      // ファイルダウンロード実行
      await downloadFile(self, response.data.user_data?.url, response.data.user_data?.file_extension);
    } else {
      // 発生日時読み出し失敗の場合
      switch (response.data?.async_code) {
        case error.WSP_UNREGISTERED_ERROR:
          // DefaultSession遷移
          await terminate(self);
          // エラー画面に遷移
          self.phase = PHASE.FAILED_SAVE;
          break;
        default:
          // 共通エラー
          await self.showUnexpectedError();
          break;
      }
    }
  } finally {
    self.isLoading = false;
  }
}

/**
 * 保存履歴表示画面で表示する項目を作成
 * @param {object} self this インスタンス
 * @param {object} fileUrl PresignedURL
 * @param {string} fileExtension ファイル拡張子
 */
async function downloadFile(self, fileUrl, fileExtension) {
  try {
    self.isLoading = true;
    if (!fileUrl) {
      self.showUnexpectedError();
    }
    //ファイル名を変更
    const formattedDate = moment().format("YYYYMMDDHHmmss");

    //URLからファイルをダウンロード
    const response = await fetch(fileUrl);
    if (response) {
      const myBlob = await response.blob();
      const objUrl = URL.createObjectURL(myBlob);
      const link = document.createElement("a");
      link.href = objUrl;
      link.download = `${formattedDate}.${fileExtension}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(objUrl);
      // DefaultSession遷移
      await terminate(self);
      // 停止画面に遷移
      self.phase = PHASE.SUCCESS;
    }
  } catch {
    self.showUnexpectedError();
  } finally {
    self.isLoading = false;
  }
}
